module.exports = __webpack_public_path__ + "media/fonts/atlasPro/AtlasProAAA-Regular-834abbe78066495567cf1533c133b7a1.svg";